import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { EMADatePhaseScoreSet } from '@demind-inc/core';

import { energyApi } from '../api';

interface UseUpdateEmayParams {
  userId: string;
  date: string;
  timezone?: string;
  emaDatePhaseScore: Partial<EMADatePhaseScoreSet>;
}

export function useUpdatePhaseEma() {
  const queryClient = useQueryClient();

  const updatePhaseEmaMutation = useMutation({
    mutationFn: ({
      userId,
      date,
      timezone = dayjs.tz.guess(),
      emaDatePhaseScore,
    }: UseUpdateEmayParams) => {
      return energyApi.updatePhaseEma(userId, date, timezone, emaDatePhaseScore);
    },
    onSuccess: (_, { date }) => {
      queryClient.invalidateQueries({ queryKey: ['phaseEma', { date }] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.circadian', { date }] });
    },
  });

  return {
    updatePhaseEma: updatePhaseEmaMutation.mutateAsync,
    ...updatePhaseEmaMutation,
  };
}
